/**
 * /u/feedback is parsed as public profile username "feedback" → Profile Not Found.
 * Rewrite to /feedback (creator feedback hub) and /feedback/:postId.
 *
 * Keep in sync with the inline script in index.html (runs before the JS bundle).
 */

export function canonicalizeMisroutedFeedbackPath() {
  if (typeof window === 'undefined') return;
  let path = window.location.pathname;
  path = path !== '/' && path.endsWith('/') ? path.slice(0, -1) : path;
  if (!path.startsWith('/')) path = '/' + path;

  if (path === '/u/feedback') {
    window.history.replaceState({}, '', '/feedback' + (window.location.search || ''));
    return;
  }
  if (path.startsWith('/u/feedback/')) {
    const rest = path.slice('/u/feedback/'.length);
    const segment = rest.split('/')[0]?.split('?')[0] || '';
    if (!segment || segment === 'new') {
      window.history.replaceState({}, '', '/feedback' + (window.location.search || ''));
    } else {
      window.history.replaceState({}, '', `/feedback/${segment}`);
    }
  }
}
